import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingMarkAsOpenAtom = createMutationAtomFactory(
  'trade.bookingMarkAsOpen',
  (params: { id: string }) => ({
    tradeBookingOpen: {
      __args: {
        id: params.id,
      },
      id: true,
    },
  }),
);
